export default __webpack_public_path__ + "static/media/forestly-expl-dissect-04_EN.b4580ee4.png";